import React, { forwardRef } from 'react';
import { WordDisplayContainer, LetterDisplay } from './styles.js';

const WordDisplay = forwardRef(({ word, guessedLetters }, ref) => {
  const revealedLetters = word
    .split('')
    .map(letter => (guessedLetters.has(letter) ? letter : '_'))
    .join(' ');

  const guessedCount = word
    .split('')
    .filter(letter => guessedLetters.has(letter)).length;
  const totalLetters = word.length;
  const uniqueLetters = new Set(word.split('')).size;

  return (
    <WordDisplayContainer
      ref={ref}
      role="group"
      aria-label={`Word to guess: ${totalLetters} letters. ${guessedCount} of ${uniqueLetters} unique letters revealed. Current word: ${revealedLetters}`}
      tabIndex={0}
    >
      {word.split('').map((letter, index) => (
        <LetterDisplay
          key={index}
          isGuessed={guessedLetters.has(letter)}
          aria-label={
            guessedLetters.has(letter)
              ? `Letter ${letter} revealed`
              : `Letter ${index + 1} not yet guessed`
          }
        >
          {guessedLetters.has(letter) ? letter : '_'}
        </LetterDisplay>
      ))}
    </WordDisplayContainer>
  );
});

WordDisplay.displayName = 'WordDisplay';

export default WordDisplay;
